import { getRemoteConfig, getString } from "firebase/remote-config";

import firebaseApp from "@/firebase/config";

export const getRemoteConfigValue = (name: string) => {
  const remoteConfig = getRemoteConfig(firebaseApp);

  return JSON.parse(getString(remoteConfig, name) || "{}");
};
